import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./store/Filters";
import axios from "axios";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  data() {
    return {
      pcodeValue: "",
      selecteddaysValue: "",
    };
  },
  methods: {
    getUserDataBySession(diffpathname) {
      debugger;
      const url = process.env.VUE_APP_URL;
      return axios
        .get(url + "session/")
        .then((response) => {
          debugger;
          //console.log('MAIN PAGE')
          //console.log(response)
          if (response.status == 401) {
            //change here
            debugger;
            console.log("Status code 401");
            window.location.assign("/ssologin" + diffpathname);
            //window.location.href('http://localhost8081/ssologin')
          } else {
            debugger;
            //console.log('username :', response.data.userName, 'phone number :', response.data.phone, ', role :', response.data.userrole, ' phone number :', response.data.phone)
            this.$store.dispatch("autoLogin", response.data.sub); //change here
            this.$store.dispatch("Name", {
              firstname: response.data.userName,
              lastname: response.data.userName,
              email: response.data.email,
              role: response.data.userrole,
              phone: response.data.phone,
            });

            if (response.data.phone != null) {
              // console.log('phone number if block:', response.data.phone)
              if (
                this.pcodeValue != null &&
                this.pcodeValue != "" &&
                this.selecteddaysValue != null &&
                this.selecteddaysValue != ""
              ) {
                debugger;
                console.log(
                  "Redirect to buy product NEST :",
                  this.pcodeValue,
                  this.selecteddaysValue
                );
                const passParams = { redirectCode: "nest" };

                this.$router.push({
                  name: "buy-product",
                  params: passParams,
                  query: {
                    pcode: this.pcodeValue,
                    selecteddays: this.selecteddaysValue,
                  },
                });
              }
              if (window.location.pathname.match("/buy-product")) {
                console.log("web service call:");
                // const passParams = {code:111}
                // this.$router.push({ name: 'buy-product', params: passParams})
              } else if (
                window.location.pathname.match("/training") ||
                window.location.pathname.match("/event")
              ) {
                debugger;
                console.log("Redirect buy product:");
                const passParams = { redirectCode: "training" };
                this.$router.push({ name: "buy-product", params: passParams });
              } else if (
                window.location.pathname.match("/conference") ||
                window.location.pathname.match("/confEvent")
              ) {
                debugger;
                console.log("Redirect buy product:");
                const passParams = { redirectCode: "conference" };
                this.$router.push({ name: "buy-product", params: passParams });
              } else this.$router.push("/");
            } else {
              //console.log('phone number else block:', response.data.phone)
              this.$router.push("/profile");
            }
          }
        })
        .catch((error) => {
          debugger;
          //console.log(error)
          if (error.response.status == 401) {
            //change here
            console.log("Catch block");
            window.location.assign("/ssologin" + diffpathname);
          } else {
            window.alert("Error Connecting Server:" + error);
          }
        });
    },
  },
  created() {
    debugger;
    // console.log('join related data :',window.location.search)

    if (window.location.pathname.match("/join")) {
      //console.log('Without authentication pass url')
      this.$store.dispatch("Name", { role: ["joinlead"] });
      this.$router.push(window.location.pathname);
    } else if (window.location.pathname.match("/payu-response")) {
      //console.log('payu-response-success')
      this.$store.dispatch("Name", { role: ["joinlead"] });
      this.$router.push("/payu-response");
    } else if (window.location.pathname.match("/fail-payu-response")) {
      //console.log('payu-response-fail')
      this.$store.dispatch("Name", { role: ["joinlead"] });
      this.$router.push("/fail-payu-response");
    } else if (window.location.pathname.match("/logout-sso")) {
      debugger;
      let urlParams = new URLSearchParams(window.location.search);
      let email = urlParams.get("email");
      let basecode = urlParams.get("basecode");
      this.$store.dispatch("Name", {
        email: email,
        role: ["joinlead"],
      });
      const passParams = { basecode: basecode };
      //  this.$router.push("/logout-sso");
      this.$router.push({ name: "logout-sso", params: passParams });
    } else if (window.location.pathname.match("/nest")) {
      debugger;

      const searchParams = new URLSearchParams(window.location.search);
      this.pcodeValue = searchParams.get("pcode");
      this.selecteddaysValue = searchParams.get("selecteddays");
      console.log(
        "After authenticate enter nest check :",
        this.pcodeValue,
        this.selecteddaysValue
      );
      this.getUserDataBySession("");
    } else {
      console.log("Else block :");
      var diffpathname = "";
      if (window.location.pathname.match("/event")) {
        diffpathname = "/event";
      } else if (window.location.pathname.match("/confEvent")) {
        diffpathname = "/confEvent";
      }
      this.getUserDataBySession(diffpathname);
    }
  },

  render: (h) => h(App),
}).$mount("#app");
